import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetAdmin } from '../../EndPoints';
import { EventObjective, EventObjectiveFilters } from '../../../models/EventObjective';

const useEventObjectiveService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetObjectives, setFetchingGetObjectives] = useState(false);
    const [fetchingStoreObjective, setFetchingStoreObjective] = useState(false);
    const [fetchingEditObjective, setFetchingEditObjective] = useState(false);
    const [fetchingUpdateObjective, setFetchingUpdateObjective] = useState(false);
    const [fetchingActiveObjective, setFetchingActiveObjective] = useState(false);
    const [fetchingDeleteObjective, setFetchingDeleteObjective] = useState(false);

    const getObjectives = (filters: EventObjectiveFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin('events/event-objectives')}?${queryString}`,
            setFetching: setFetchingGetObjectives
        });
    };

    const storeObjective = (objective: EventObjective, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: `${buildEndpointIntranetAdmin('events/event-objectives/store')}`,
            type: 'admin',
            body: objective,
            setFetching: setFetchingStoreObjective
        });
    };

    const editObjective = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-objectives/${id.toString()}/edit`)}`,
            setFetching: setFetchingEditObjective
        });
    };

    const updateObjective = (id: number, objective: EventObjective, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-objectives/${id.toString()}/update`)}`,
            body: objective,
            setFetching: setFetchingUpdateObjective
        });
    };

    const activeObjective = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-objectives/${id.toString()}/active`)}`,
            body: { active: active },
            setFetching: setFetchingActiveObjective
        });
    };

    const deleteObjective = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(`events/event-objectives/${id.toString()}/delete`)}`,
            setFetching: setFetchingDeleteObjective
        });
    };

    return {
        fetchingGetObjectives,
        fetchingStoreObjective,
        fetchingEditObjective,
        fetchingUpdateObjective,
        fetchingActiveObjective,
        fetchingDeleteObjective,
        getObjectives,
        storeObjective,
        editObjective,
        updateObjective,
        activeObjective,
        deleteObjective
    };
};

export default useEventObjectiveService; 